var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F7386473E99D494C33AccountabilityIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_17856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.7861,
    cy: 14,
    r: 14,
    fill: "#FF7020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9947 12.3335H1.00024V55.0002H38.4495V12.3335H28.1847",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9289 16.2043C28.9289 14.9956 28.6908 13.7987 28.2282 12.682C27.7657 11.5653 27.0877 10.5506 26.233 9.69588C25.3783 8.84118 24.3636 8.16319 23.2469 7.70064C22.1302 7.23808 20.9333 7 19.7246 7C18.5158 7 17.3189 7.23808 16.2022 7.70064C15.0855 8.1632 14.0708 8.84118 13.2161 9.69588C12.3614 10.5506 11.6835 11.5653 11.2209 12.682C10.7583 13.7987 10.5203 14.9956 10.5203 16.2043L19.7246 16.2043H28.9289Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_17856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F7386473E99D494C33AccountabilityIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f7386473e99d494c33_accountability-icon-darkstudio-x-webflow-template.9f77784b13413782601995abfb48a9fe.svg";
export { ForwardRef as ReactComponent };